<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="commodityId ? '修改商品' : '新增商品'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="commodityInfo"
        label-position="right"
        label-width="100px"
        ref="editFormRef"
        v-loading="loading"
        :rules="{
          sysFileIdList: $ruleUtil.array('商品图片', '上传', 0, 10),
          name: $ruleUtil.simple({
            fieldName: '商品名称',
            required: true,
            max: 50,
          }),
          commodityCategoryId: $ruleUtil.simple({
            fieldName: '商品分类',
            handleType: '选择',
            required: true,
          }),
          unit: $ruleUtil.simple({
            fieldName: '单位',
            required: true,
            max: 20,
          }),
          specAddNewPojoList: $ruleUtil.array('商品规格', '填写', 1),
        }"
        v-if="commodityInfo"
      >
        <el-form-item label="商品图片" class="fm-mt-10" prop="sysFileIdList">
          <div
            class="fm-rela commodityImage"
            v-for="(file, index) in imageList"
            :key="index"
          >
            <el-image
              :id="'commodityImage' + index"
              class="commodityImage"
              :src="file.url"
              :preview-src-list="imageList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div
              class="commodityImageLoadingIcon fm-center"
              v-if="file.status == 'ready'"
            >
              <i
                class="commodityImageLoadingIcon-icon el-icon el-icon-loading"
              ></i>
            </div>
            <div class="commodityImageHandleIcon">
              <i
                @click="commodityFilePreview(index)"
                alt="预览图片"
                class="commodityImageHandleIcon-icon fm-center commodityImageHandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="commodityFileDelete(index, file)"
                class="commodityImageHandleIcon-icon fm-center commodityImageHandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadCommodityImage + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="imageList"
            :show-file-list="false"
            :on-progress="commodityFileProgress"
            :on-success="commodityFileSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="imageList.length < 10"
          >
            <div slot="default" class="fm-center commodityImage">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input
            v-model="commodityInfo.name"
            style="width: 400px"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品分类" prop="commodityCategoryId">
          <CommodityCategorySelectDialog
            v-model="commodityCategoryInfo"
            @select="selectCommodityCategory"
          ></CommodityCategorySelectDialog>
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-input
            v-model="commodityInfo.unit"
            style="width: 400px"
            placeholder="请输入商品单位"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品类型" prop="multiSpecMark">
          <el-tooltip
            slot="label"
            content="设置此商品是单规格商品还是多规格商品，新增商品时设置，提交后不可修改"
            placement="top"
          >
            <span>
              <i class="el-icon-question"></i>
              商品类型
            </span>
          </el-tooltip>
          <el-radio-group
            v-model="commodityInfo.multiSpecMark"
            :disabled="!!commodityInfo.id"
          >
            <el-radio :label="true">
              <span v-fmtype="'primary'">多规格商品</span>
            </el-radio>
            <el-radio :label="false">
              <span v-fmtype="'warning'">单规格商品</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="冻结状态" prop="frozen">
          <el-radio-group v-model="commodityInfo.frozen">
            <el-radio :label="false">
              <span v-fmtype="'success'">未冻结</span>
            </el-radio>
            <el-radio :label="true">
              <span v-fmtype="'danger'">已冻结</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="commodityInfo.multiSpecMark">
          <el-form-item label="商品规格" prop="specAddNewPojoList">
            <div class="fm-flex">
              <p
                v-fmtype="'success'"
                v-if="
                  commodityInfo.specAddNewPojoList &&
                  commodityInfo.specAddNewPojoList.length > 0
                "
              >
                {{
                  "共 " +
                  commodityInfo.specAddNewPojoList.length +
                  " 个商品规格"
                }}
              </p>
              <span v-fmtype="'error'" v-else>未添加商品规格</span>
              <el-button
                class="fm-ml-15"
                type="primary"
                plain
                size="mini"
                icon="el-icon-plus"
                @click="showSpecAddNewPopup"
                >新增规格</el-button
              >
            </div>
          </el-form-item>
          <el-table
            :data="commodityInfo.specAddNewPojoList || []"
            stripe
            max-height="500px"
            style="width: 100%"
            :row-key="(row) => Math.random()"
          >
            <el-table-column
              label="规格图片"
              width="100"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <CommodityImage
                  :commodity="scope.row"
                  size="60px"
                ></CommodityImage>
              </template>
            </el-table-column>
            <el-table-column
              label="规格信息"
              min-width="200"
              align="left"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div style="line-height: 1.4em">
                  <div style="font-size: 1.1em">
                    {{ "规格名称：" + scope.row.specName }}
                  </div>
                  <div class="fm-mt-5">
                    {{ "条码：" + (scope.row.barCode || "—") }}
                  </div>
                  <span v-fmtype="'success'" v-if="scope.row.inProduction"
                    >在产</span
                  >
                  <span v-fmtype="'danger'" v-else>已停产</span>
                  <span v-fmtype="'danger'" v-if="scope.row.frozen"
                    >已冻结</span
                  >
                  <span v-fmtype="'success'" v-else>未冻结</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="可用库存"
              width="150"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.id ? scope.row.availableQuantity : "———" }}
              </template>
            </el-table-column>
            <el-table-column
              label="现有库存"
              width="150"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.id ? "———" : scope.row.nowQuantity }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="$jsTool.currentUserCanSeePrice()"
              label="进货价"
              width="150"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <FmAmount :amount="scope.row.retailPrice"></FmAmount>
              </template>
            </el-table-column>
            <el-table-column
              label="零售价"
              width="150"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <FmAmount :amount="scope.row.buyingPrice"></FmAmount>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              header-align="center"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.stop="
                    showSpecEditPopup(scope.row, scope.$index)
                  "
                  type="text"
                  icon="el-icon-edit"
                >
                  编辑
                </el-button>
                <el-button
                  @click.native.stop="deleteSpec(scope.row, scope.$index)"
                  type="text"
                  icon="el-icon-delete"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-form
            :model="commodityInfo.singleSpecInfo"
            label-position="right"
            label-width="100px"
            ref="specEditForm"
            :rules="{
              barCode: $ruleUtil.simple({
                fieldName: '条码',
                required: false,
                max: 50,
              }),
              nowQuantity: $ruleUtil.number('现有库存', 0),
            }"
          >
            <el-form-item label="条码" prop="barCode">
              <el-input
                v-model="commodityInfo.singleSpecInfo.barCode"
                style="width: 280px"
                placeholder="请输入或录入条码"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="现有库存"
              prop="nowQuantity"
              v-if="!commodityInfo.singleSpecInfo.id"
            >
              <el-input-number
                v-model="commodityInfo.singleSpecInfo.nowQuantity"
                :min="0"
                label="请填写现有库存"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="进货价"
              v-if="$jsTool.currentUserCanSeePrice()"
            >
              <el-input-number
                style="width: 170px"
                v-model="commodityInfo.singleSpecInfo.retailPrice"
                label="进货价"
                size="small"
                :precision="2"
                :min="0"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="零售价">
              <el-input-number
                style="width: 170px"
                v-model="commodityInfo.singleSpecInfo.buyingPrice"
                label="零售价"
                size="small"
                :precision="2"
                :min="0"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="是否在产">
              <el-radio-group
                v-model="commodityInfo.singleSpecInfo.inProduction"
              >
                <el-radio :label="true">
                  <span v-fmtype="'success'">在产</span>
                </el-radio>
                <el-radio :label="false">
                  <span v-fmtype="'danger'">已停产</span>
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save"> 保 存 </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="specEditIndex == null ? '新增商品规格' : '修改商品规格'"
      :visible="specEditPopupShow"
      width="600px"
      @close="specEditPopupCancel"
      v-loading="specloading"
      v-if="specEditPopupShow"
    >
      <el-form
        :model="specEditPojo"
        label-position="right"
        label-width="100px"
        ref="specEditForm"
        :rules="{
          sysFileIdList: $ruleUtil.array('规格图片', '上传', 0, 6),
          specName: $ruleUtil.simple({
            fieldName: '规格名称',
            required: true,
            max: 50,
          }),
          barCode: $ruleUtil.simple({
            fieldName: '条码',
            required: false,
            max: 50,
          }),
          nowQuantity: $ruleUtil.number('现有库存', 0),
        }"
        v-if="specEditPojo && typeof specEditPojo.specName != 'undefined'"
      >
        <el-form-item label="规格图片" class="fm-mt-10" prop="sysFileIdList">
          <div
            class="fm-rela commoditySpecImage"
            v-for="(file, index) in specEditPojo.imageList"
            :key="index"
          >
            <el-image
              :id="'commoditySpecImage' + index"
              class="commoditySpecImage"
              :src="file.url"
              :preview-src-list="specEditPojo.imageList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div
              class="commoditySpecImageLoadingIcon fm-center"
              v-if="file.status == 'ready'"
            >
              <i
                class="commoditySpecImageLoadingIcon-icon el-icon el-icon-loading"
              ></i>
            </div>
            <div class="commoditySpecImageHandleIcon">
              <i
                @click="commoditySpecFilePreview(index)"
                alt="预览图片"
                class="commoditySpecImageHandleIcon-icon fm-center commoditySpecImageHandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="commoditySpecFileDelete(index, file)"
                class="commoditySpecImageHandleIcon-icon fm-center commoditySpecImageHandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadCommodityImage + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="6"
            multiple
            accept="image/*"
            :file-list="specEditPojo.imageList"
            :show-file-list="false"
            :on-progress="commoditySpecFileProgress"
            :on-success="commoditySpecFileSuccess"
            :on-exceed="() => this.$message.warning('最多上传6张图片')"
            v-if="specEditPojo.imageList.length < 6"
          >
            <div slot="default" class="fm-center commoditySpecImage">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="规格名称" prop="specName">
          <el-input
            v-model="specEditPojo.specName"
            style="width: 280px"
            placeholder="请输入规格名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="条码" prop="barCode">
          <el-input
            v-model="specEditPojo.barCode"
            style="width: 280px"
            placeholder="请输入或录入条码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="现有库存"
          prop="nowQuantity"
          v-if="!specEditPojo.id"
        >
          <el-input-number
            v-model="specEditPojo.nowQuantity"
            :min="0"
            label="请填写现有库存"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="进货价" v-if="$jsTool.currentUserCanSeePrice()">
          <el-input-number
            style="width: 170px"
            v-model="specEditPojo.retailPrice"
            label="进货价"
            size="small"
            :precision="2"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="零售价">
          <el-input-number
            style="width: 170px"
            v-model="specEditPojo.buyingPrice"
            label="零售价"
            size="small"
            :precision="2"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="是否在产">
          <el-radio-group v-model="specEditPojo.inProduction">
            <el-radio :label="true">
              <span v-fmtype="'success'">在产</span>
            </el-radio>
            <el-radio :label="false">
              <span v-fmtype="'danger'">已停产</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="冻结状态" prop="frozen">
          <el-radio-group v-model="specEditPojo.frozen">
            <el-radio :label="false">
              <span v-fmtype="'success'">未冻结</span>
            </el-radio>
            <el-radio :label="true">
              <span v-fmtype="'danger'">已冻结</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="specEditPopupCancel">取 消</el-button>
        <el-button type="primary" @click="specEditPopupConfirm">
          保 存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FmAmount from "./fm/FmAmount.vue";
export default {
  components: { FmAmount },
  name: "Fmerpv2WebCommodityEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    commodityId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.$nextTick(async () => {
              this.getTenantQuantityDigit();
            });
          }, 100);
        }
        this.$nextTick(() => {
          this.$refs.editFormRef.clearValidate();
        });
      },
      immediate: true,
    },
    commodityId: {
      handler(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.getCommodityInfo();
          }, 100);
        } else {
          setTimeout(() => {
            this.getDefaultCommodityCategory();
          }, 100);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      id: null,
      loading: false,
      specloading: false,
      commodityCategoryInfo: {},
      commodityInfo: {
        sysFileIdList: [],
        name: "",
        commodityCategoryId: null,
        unit: "个",
        multiSpecMark: true,
        frozen: false,
        specAddNewPojoList: [],
        singleSpecInfo: {
          sysFileIdList: [],
          imageList: [],
          specName: "",
          barCode: "",
          nowQuantity: 0,
          buyingPrice: "0.00",
          retailPrice: "0.00",
          inProduction: true,
          frozen: false,
        },
      },
      imageList: [],

      specEditPopupShow: false,
      specEditIndex: 0,
      specEditPojo: {},

      precision: 3,
    };
  },
  mounted() {},
  methods: {
    async getDefaultCommodityCategory() {
      let res = await this.$api.commodityCategory_getDefault();
      if (res && res.success) {
        this.commodityCategoryInfo = res.data;
        this.commodityInfo.commodityCategoryId = res.data.id;
      }
    },
    getTenantQuantityDigit() {
      let tenantSimplifiedPojo = this.$storageUtil.getTenantSimplifiedPojo();
      this.precision = Number(tenantSimplifiedPojo.commodityQuantityDigit || 0);
    },
    async deleteSpec(item, index) {
      let that = this;
      if (item.id) {
        let res = await this.$api.commoditySnapshot_commoditySpecUsed(item.id, {
          showLoading: true,
          loadingParam: {
            target: "#editDialog > *",
            lock: true,
            text: "加载中...",
          },
        });
        if (res && res.success && res.data > 0) {
          this.$alert(
            "规格" + item.specName + "已被单据使用，无法删除，如不再需要请冻结",
            "操作提醒",
            { confirmButtonText: "确定" }
          );
          return;
        }
      }
      this.$confirm("是否删除规格" + item.specName + "？", "操作提醒", {
        confirmButtonText: "继续删除",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
      }).then(() => {
        that.commodityInfo.specAddNewPojoList.splice(index, 1);
      });
    },
    showSpecAddNewPopup() {
      this.loading = true;
      this.specEditPojo = {
        sysFileIdList: [],
        imageList: [],
        specName: "",
        barCode: "",
        nowQuantity: 0,
        buyingPrice: "0.00",
        retailPrice: "0.00",
        inProduction: true,
        frozen: false,
      };
      this.specEditIndex = null;
      this.specEditPopupShow = true;
      this.loading = false;
    },
    showSpecEditPopup(item, index) {
      this.specloading = true;
      this.specEditPojo = JSON.parse(JSON.stringify(item));
      this.specEditPojo.imageList = item.imageList.map((item) => {
        if (item.sysFile) {
          return {
            ...item,
            imageName: item.sysFile.name,
            id: item.sysFile.id,
            message: "已有图片",
            status: "success",
            thumb: item.sysFile.prefix + item.sysFile.name,
            type: "image",
            url: item.sysFile.prefix + item.sysFile.name,
          };
        } else {
          return {
            ...item,
            imageName: item.name,
            id: item.id,
            message: "已有图片",
            status: "success",
            thumb: item.url,
            type: "image",
            url: item.url,
          };
        }
      });
      this.specEditIndex = index || 0;
      this.specEditPopupShow = true;
      setTimeout(() => {
        this.specloading = false;
      }, 100);
    },
    specEditPopupCancel() {
      let that = this;
      this.$confirm(
        "取消将不会把修改的信息应用到商品，是否继续？",
        "操作提醒",
        {
          confirmButtonText: "继续取消",
          cancelButtonText: "返回修改",
          type: "success",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        }
      )
        .then(() => {
          that.specEditPojo = {};
          that.specEditPopupShow = false;
        })
        .catch(() => {});
    },
    specEditPopupConfirm() {
      this.$refs.specEditForm
        .validate()
        .then(async (validateRes) => {
          this.specloading = true;
          if (this.specEditIndex == null) {
            this.commodityInfo.specAddNewPojoList.push(this.specEditPojo);
          } else {
            this.commodityInfo.specAddNewPojoList.splice(
              this.specEditIndex,
              1,
              this.specEditPojo
            );
          }
          this.specloading = false;
          this.specEditPojo = {};
          this.specEditPopupShow = false;
        })
        .catch((errors) => {});
    },
    // 选择商品分类
    selectCommodityCategory(commodityCategory) {
      this.commodityCategoryInfo = commodityCategory;
      this.commodityInfo.commodityCategoryId = commodityCategory.id;
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.validateField("commodityCategoryId");
        }
      });
    },
    // 商品图片有关
    commodityFilePreview(index) {
      document.getElementById("commodityImage" + index).click();
    },
    commodityFileDelete(index, file) {
      this.imageList.splice(index, 1);
      this.$nextTick(() => {
        this.commodityInfo.sysFileIdList = this.imageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editFormRef.validateField("sysFileIdList");
      });
    },
    commodityFileProgress(event, file, fileList) {
      this.imageList.push({
        ...file,
        url: file.url || URL.createObjectURL(file.raw),
        status: "ready",
      });
      this.$nextTick(() => {
        this.commodityInfo.sysFileIdList = this.imageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editFormRef.validateField("sysFileIdList");
      });
    },
    commodityFileSuccess(res, file, fileList) {
      let index = this.imageList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.imageList.splice(index, 1, {
          ...this.imageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: "文件上传失败",
          type: "error",
        });
        this.imageList.splice(index, 1);
      }
      this.$nextTick(() => {
        this.commodityInfo.sysFileIdList = this.imageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editFormRef.validateField("sysFileIdList");
      });
    },

    // 商品规格图片有关
    commoditySpecFilePreview(index) {
      document.getElementById("commoditySpecImage" + index).click();
    },
    commoditySpecFileDelete(index, file) {
      this.specEditPojo.imageList.splice(index, 1);
      this.$nextTick(() => {
        this.specEditPojo.sysFileIdList = this.specEditPojo.imageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.specEditForm.validateField("sysFileIdList");
      });
    },
    commoditySpecFileProgress(event, file, fileList) {
      this.specEditPojo.imageList.push({
        ...file,
        url: file.url || URL.createObjectURL(file.raw),
        status: "ready",
      });
      this.$nextTick(() => {
        this.specEditPojo.sysFileIdList = this.specEditPojo.imageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.specEditForm.validateField("sysFileIdList");
      });
    },
    commoditySpecFileSuccess(res, file, fileList) {
      let index = this.specEditPojo.imageList.findIndex(
        (d) => d.uid == file.uid
      );
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.specEditPojo.imageList.splice(index, 1, {
          ...this.specEditPojo.imageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: "文件上传失败",
          type: "error",
        });
        this.specEditPojo.imageList.splice(index, 1);
      }
      this.$nextTick(() => {
        this.specEditPojo.sysFileIdList = this.specEditPojo.imageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.specEditForm.validateField("sysFileIdList");
      });
    },

    async save() {
      let that = this;
      that.$refs.editFormRef
        .validate()
        .then(async (validateRes) => {
          if (!that.commodityInfo.multiSpecMark) {
            // 校验规格
            let checkRes = await new Promise((resolve, reject) => {
              that.$refs.specEditForm
                .validate()
                .then((validateRes) => {
                  resolve(true);
                })
                .catch((errors) => {
                  reject(false);
                });
            });
            if (!checkRes) {
              return;
            }
          }
          let param = {
            ...that.commodityInfo,
            specAddNewPojoList: that.commodityInfo.multiSpecMark
              ? that.commodityInfo.specAddNewPojoList
              : [
                  {
                    ...that.commodityInfo.singleSpecInfo,
                    specName: that.commodityInfo.name,
                  },
                ],
          };
          let res = that.commodityId
            ? await that.$api.commodity_update(param, {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "更新中...",
                },
              })
            : await that.$api.commodity_addNew(param, {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              });
          if (res && res.success) {
            setTimeout(() => {
              that.close(true);
            }, 1000);
          }
        })
        .catch((errors) => {});
    },

    async getCommodityInfo(args) {
      this.loading = true;
      let res = await this.$api.commodity_findById(this.commodityId, args);
      if (res && res.success) {
        // 初始化数据
        this.commodityInfo = {
          ...res.data,
          sysFileIdList: res.data.imageList.map((item) => item.sysFile.id),
          specAddNewPojoList: res.data.commoditySpecList.map((d) => {
            let item = d;
            return {
              ...item,
              sysFileIdList: d.imageList.map((item) => item.sysFile.id),
            };
          }),
        };
        this.imageList = res.data.imageList.map((item) => {
          return {
            imageName: item.sysFile.name,
            id: item.sysFile.id,
            message: "已有图片",
            status: "success",
            thumb: item.sysFile.prefix + item.sysFile.name,
            type: "image",
            url: item.sysFile.prefix + item.sysFile.name,
            sysFile: item.sysFile,
          };
        });
        this.commodityCategoryInfo = res.data.commodityCategory;
        if (!res.data.multiSpecMark) {
          this.commodityInfo.singleSpecInfo =
            this.commodityInfo.specAddNewPojoList[0];
        }
      }
      setTimeout(() => {
        this.loading = false;
      }, 200);
    },
    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style lang="scss" scoped>
.commodityImage {
  float: left;
  width: 100px !important;
  height: 100px !important;
  margin-right: 10px;
  border: 1px dashed var(--fm-border-color);
  border-radius: 5px;
  background-color: var(--fm-border-extralight-color);
  overflow: hidden;
  cursor: pointer;

  &:hover {
    border: 1px dashed var(--fm-primary-color);
  }
}

.commodityImageLoadingIcon {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100px;
  height: 100px;

  &-icon {
    color: white;
    font-size: 18px;
  }
}

.commodityImageHandleIcon {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0;
  width: 100px;
  height: 100px;

  &:hover {
    opacity: 1;
  }

  &-icon {
    position: absolute;
    top: 0;
    width: 50px;
    height: 100px;
    color: white;
    font-size: 18px;
  }

  &-previewIcon {
    left: 0;
  }

  &-deleteIcon {
    left: 50px;
  }
}

.commoditySpecImage {
  float: left;
  width: 100px !important;
  height: 100px !important;
  margin-right: 10px;
  border: 1px dashed var(--fm-border-color);
  border-radius: 5px;
  background-color: var(--fm-border-extralight-color);
  overflow: hidden;
  cursor: pointer;

  &:hover {
    border: 1px dashed var(--fm-primary-color);
  }
}

.commoditySpecImageLoadingIcon {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100px;
  height: 100px;

  &-icon {
    color: white;
    font-size: 18px;
  }
}

.commoditySpecImageHandleIcon {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0;
  width: 100px;
  height: 100px;

  &:hover {
    opacity: 1;
  }

  &-icon {
    position: absolute;
    top: 0;
    width: 50px;
    height: 100px;
    color: white;
    font-size: 18px;
  }

  &-previewIcon {
    left: 0;
  }

  &-deleteIcon {
    left: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommodityEditDialog.vue